import React from 'react';

// material components
import {
    Toolbar,
    Typography,
    Tooltip,
    IconButton,
} from "@material-ui/core";

// material icons
import {
    AddCircle as Add,
} from '@material-ui/icons';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';

// styling
import '../global/TableToolbar.css';

// constants
import PropTypes from "prop-types";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import {userInfoSelector} from "../../redux/selectors/auth";
import withShipment from "../../withShipment";
import Utils from "../Utils/Utils";

class SettingsToolbar extends React.PureComponent {

    render() {
        return (
            <Toolbar className="toolbar"
                     style={{
                         backgroundColor: Utils.isValidColor(this.props.userInfo?.employeeColor)
                             ? this.props.userInfo?.employeeColor
                             :"#7896ff"}}
            >

                <div className="contextualMenu">
                    {this.props.addingOrEditing ?
                        <>
                        <Tooltip title="Back">
                            <IconButton onClick={this.props.title === "" ? this.props.handleBack : this.props.handleClose}>
                                <KeyboardBackspaceIcon />
                            </IconButton>
                        </Tooltip>
                            {this.props.title === "" &&
                                <Tooltip title={"Next"}>
                                    <IconButton
                                        disabled={this.props.disableNextStep || this.props.onSavingStep}
                                        onClick={this.props.nextStep}>
                                        <ArrowForwardIcon/>
                                    </IconButton>
                                </Tooltip>
                            }
                        </>
                        :
                        (this.props.hideCreate ? null :
                            <Tooltip title={this.props.title === "Manage Employee" ? "Add Employee" : this.props.title}>
                                <IconButton onClick={this.props.handleCreateOpen}>
                                    <Add />
                                </IconButton>
                            </Tooltip>
                        )
                    }
                    

                </div>

                <Typography className="titleTypography" variant="h6" id="tableTitle">
                    {this.props.title}
                </Typography>

            </Toolbar>
        );
    }

}

SettingsToolbar.propTypes = {
    title: PropTypes.string,
    handleCreateOpen: PropTypes.func,
    handleEditOpen: PropTypes.func,
    selected: PropTypes.object,
    handleDeleteOpen: PropTypes.func,
    handleDeleteClose: PropTypes.func,
    handleDelete: PropTypes.func,
    deleteOpen: PropTypes.bool
}

SettingsToolbar.defaultProps = {
    title: "No title specified",
    selected: {},
    handleDelete: ()=>{},
    deleteOpen: false
}

const mapStateToProps = (state) => ({
    userInfo: userInfoSelector(state)
})

export default withShipment({
    mapStateToProps,
}, SettingsToolbar);